var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_e-FormButtonOK",class:{
      '_e-FormButtonOK--visible' : _vm.visible
    }},[_c('button',{staticClass:"_e-FormButtonOK__button",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("OK")]),_c('span',{staticClass:"_e-FormButtonOK__text"},[_vm._v("Appuyez sur ENTER")])])}
var staticRenderFns = []

export { render, staticRenderFns }